import { FaGithub, FaLinkedin } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import profile from "../../assets/img/myprofilebgless.png";
import contactGif from '../../assets/img/contact-gif.gif'
import { SiFiverr } from "react-icons/si";

const Contact = () => {

  return (
    <div className='  pb-24 relative top-[20px] rounded-t-3xl w-full flex flex-col items-center justify-center text-white'>
        <div className='w-[97%] xl:w-[80%] gap-x-10 flex items-center justify-between'>
        {/* left */}
        <div className='flex flex-col  justify-center p-4 rounded-xl bg-[#1d1d1d] shadow-black shadow-lg gap-y-6 lg:gap-y-12 w-full md:w-auto'  data-aos='flip-right' data-aos-offset='100' data-aos-delay='600'>
        <h5 className='text-[48px] lg:text-[58px] xl:text-[65px] font-bold w-[90%] lg:w-[70%] '>Let's work together</h5>
        
        <div>
            <div className='font-bold text-[20px] flex items-center'><h6>Mail</h6> <img src={contactGif} alt="conmtact Gif" className='h-9'/></div>
            <a href="mailto:contact@gulfamhaider.com?subject=Interested%20in%20your%20offer!" className='hover:text-white'><p>contact@gulfamhaider.com</p></a>
        </div>
        <div>
        <div className='font-bold text-[20px] flex items-center gap-x-2'><h6>Platforms</h6> <MdWork size={20} className='text-[#ffffff]'/></div>
            <div className='flex items-center mt-2 gap-x-3'>
                
                <a href="https://www.linkedin.com/in/gulfam-haider-861016291/" target="_blank" rel="noopener noreferrer"><FaLinkedin size={33} className='text-[#26ADF6]'  title='LinkedIn Profile'/></a>
                <a href="https://github.com/Gulfam619" target="_blank" rel="noopener noreferrer"><div  className='bg-black rounded-full p-1 '  title='Fiverr Profile'><FaGithub    size={23} className='text-white'/></div></a>
                <a href="https://www.fiverr.com/gulfam207" target="_blank" rel="noopener noreferrer"><div  className='bg-[#1f6e38] rounded-full p-1 '  title='Fiverr Profile'><SiFiverr     size={23} className='text-white'/></div></a>
            </div>
        </div>
        </div>

        {/* right */}
        <img src={profile} alt="profile" className='hidden md:block md:w-[42%] lg:w-[450px] xl:w-[480px]  '  data-aos='fade-left' data-aos-offset='100' data-aos-delay='100'/>
        </div>
    
    </div>
  )
}

export default Contact